import { render, staticRenderFns } from "./LinkMobile.vue?vue&type=template&id=506a6ff4&scoped=true"
import script from "./LinkMobile.vue?vue&type=script&lang=js"
export * from "./LinkMobile.vue?vue&type=script&lang=js"
import style0 from "./LinkMobile.vue?vue&type=style&index=0&id=506a6ff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a6ff4",
  null
  
)

export default component.exports